(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initSlideshow(el) {
    if (!el || el.dataset.swiperWired === 'true') return;
    if (typeof Swiper === 'undefined') {
      // Swiper not yet loaded — retry shortly.
      setTimeout(() => initSlideshow(el), 50);
      return;
    }
    el.dataset.swiperWired = 'true';

    var blockCount = parseInt(el.getAttribute('data-block-count'), 10) || 0;
    if (blockCount < 2) return;

    var autoplay = el.getAttribute('data-autoplay') === 'true';
    var speedSetting = parseFloat(el.getAttribute('data-autoplay-speed')) || 7;
    var style = el.getAttribute('data-style') || 'bars';

    var paginationEl = el.querySelector('.swiper-pagination');
    var paginationConfig = false;
    if (paginationEl && style !== 'arrows') {
      paginationConfig = {
        el: paginationEl,
        clickable: true,
        type: style === 'bars' ? 'progressbar' : 'bullets',
      };
    }

    var navConfig = false;
    if (style === 'arrows') {
      navConfig = {
        prevEl: el.querySelector('.swiper-button-prev'),
        nextEl: el.querySelector('.swiper-button-next'),
      };
    }

    var swiper = new Swiper(el, {
      effect: 'fade',
      fadeEffect: { crossFade: true },
      speed: 800,
      loop: blockCount > 1,
      grabCursor: true,
      autoplay: autoplay ? {
        delay: speedSetting * 1000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      } : false,
      pagination: paginationConfig,
      navigation: navConfig,
      a11y: {
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
      },
    });

    // Pause autoplay when tab is hidden, resume when visible.
    document.addEventListener('visibilitychange', () => {
      if (!swiper.autoplay) return;
      if (document.hidden) swiper.autoplay.pause();
      else swiper.autoplay.resume();
    });
  }

  function init() {
    document.querySelectorAll('.alorae-section--slideshow .swiper.slideshow').forEach(initSlideshow);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (e) => {
    if (!e.target) return;
    var els = e.target.querySelectorAll('.alorae-section--slideshow .swiper.slideshow');
    els.forEach((el) => {
      /* Fresh DOM, but defensive — if a Swiper somehow still exists, drop it. */
      if (el.swiper) { try { el.swiper.destroy(true, true); } catch (err) {} }
      el.dataset.swiperWired = '';
      initSlideshow(el);
    });
  });
  document.addEventListener('shopify:section:unload', (e) => {
    if (!e.target) return;
    e.target.querySelectorAll('.alorae-section--slideshow .swiper.slideshow').forEach((el) => {
      if (el.swiper) { try { el.swiper.destroy(true, true); } catch (err) {} }
    });
  });
  document.addEventListener('shopify:block:select', (e) => {
    /* Slide to the block the merchant just selected so they can edit it. */
    var slide = e.target.closest('.swiper-slide');
    var root = slide && slide.closest('.swiper.slideshow');
    if (root && root.swiper) {
      var idx = Array.prototype.indexOf.call(root.querySelectorAll('.swiper-slide'), slide);
      if (idx >= 0) root.swiper.slideTo(idx);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
